module.exports = __webpack_public_path__ + "static/media/save-money.83d19750.svg";